import React from "react";
import { Icon } from "semantic-ui-react";

const DatabaseIconGroup = () => {
  return (
    <div className="icon-group">
      <Icon.Group>
        <Icon name="database" size="large" className="base-icon" />
        <Icon name="database" size="large" className="overlap-icon" />
      </Icon.Group>
    </div>
  );
};

export default DatabaseIconGroup;
